module.exports = __webpack_public_path__ + "static/media/ye.3b3f08ad.svg";